import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PwaService } from 'src/app/_utils/pwa/pwa.service';
import { StorageService } from 'src/app/_utils/storage/storage.service';

@Component({
  selector: 'app-full',
  templateUrl: './full.component.html',
  styleUrl: './full.component.scss'
})
export class FullComponent {
  message: any = { visible: false, text: '', title: '' };
  pullProgress = 0;
  reloading = false;
  private PULL_START_THRESHOLD = 20; // Mostra il loader dopo {x}px
  private PULL_RELOAD_THRESHOLD = 150; // Attiva il reload a {x}px

  constructor(
    protected router: Router,
    private route: ActivatedRoute,
    private pwaService: PwaService,
    private storageService: StorageService,
  ) {
    // Se l'URL contiene un UID come prefisso (es. /{uid}/...), lo salviamo
    // nel localStorage così sarà disponibile per le successive chiamate API.
    const uid = this.route.snapshot.params['uid'];
    if (uid) {
      this.storageService.setUID(uid);
    }
  }

  @HostListener('window:scroll', ['$event'])
  onSwipe(event: any) {
    if (!this.pwaService.isInstalled()) return;

    const scrollY = window.scrollY;

    // Se si scrolla verso l'alto (scrollY negativo)
    if (scrollY < 0) {
      const absScroll = Math.abs(scrollY);

      // Mostra il loader solo dopo il threshold iniziale
      if (absScroll >= this.PULL_START_THRESHOLD) {
        // Calcola il progresso da PULL_START_THRESHOLD a PULL_RELOAD_THRESHOLD
        const progress = Math.min(
          ((absScroll - this.PULL_START_THRESHOLD) / (this.PULL_RELOAD_THRESHOLD - this.PULL_START_THRESHOLD)) * 100,
          100
        );
        this.pullProgress = progress;

        // Quando raggiunge 100%, attiva il reload
        if (progress >= 100 && !this.reloading) {
          this.reloading = true;
          this.pullProgress = 0;
          event.preventDefault();
          setTimeout(() => document.location.reload(), 600);
        }
      } else {
        this.pullProgress = 0;
      }
    } else {
      // Reset quando si smette di scrollare verso l'alto
      if (this.pullProgress > 0 && !this.reloading) {
        this.pullProgress = 0;
      }
    }
  }
}
